// Copyright 2021
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/trait/activities/v1/activity_level.proto (package msh.trait.activities.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { CaptureMode } from "../../../common/v1/capture_mode_pb";

/**
 * @generated from message msh.trait.activities.v1.ActivityLevelTrait
 */
export const ActivityLevelTrait = proto3.makeMessageType(
  "msh.trait.activities.v1.ActivityLevelTrait",
  [],
);

/**
 * @generated from message msh.trait.activities.v1.ActivityLevelTrait.ActivityLevelEvent
 */
export const ActivityLevelTrait_ActivityLevelEvent = proto3.makeMessageType(
  "msh.trait.activities.v1.ActivityLevelTrait.ActivityLevelEvent",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "mean", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "std_deviation", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "min", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "q1", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "q2", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "q3", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "max", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "num_sample", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 10, name: "level", kind: "enum", T: proto3.getEnumType(ActivityLevelTrait_ActivityLevelEvent_Level) },
    { no: 11, name: "capture_mode", kind: "enum", T: proto3.getEnumType(CaptureMode) },
  ],
  {localName: "ActivityLevelTrait_ActivityLevelEvent"},
);

/**
 * @generated from enum msh.trait.activities.v1.ActivityLevelTrait.ActivityLevelEvent.Level
 */
export const ActivityLevelTrait_ActivityLevelEvent_Level = proto3.makeEnum(
  "msh.trait.activities.v1.ActivityLevelTrait.ActivityLevelEvent.Level",
  [
    {no: 0, name: "LEVEL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LEVEL_ABSENT", localName: "ABSENT"},
    {no: 2, name: "LEVEL_MICRO_ACTIVE", localName: "MICRO_ACTIVE"},
    {no: 3, name: "LEVEL_LIGHTLY_ACTIVE", localName: "LIGHTLY_ACTIVE"},
    {no: 4, name: "LEVEL_MODERATELY_ACTIVE", localName: "MODERATELY_ACTIVE"},
    {no: 5, name: "LEVEL_STRONGLY_ACTIVE", localName: "STRONGLY_ACTIVE"},
  ],
);

